export const isLoggedIn = () => localStorage.getItem("DfsWeb.isLoggedIn") === "true";

export const agriMarketBase = () => `${window.contextPath}/agri-market`;

export const brandSelectedPath = (brandId, categoryId) => {
  const params = new URLSearchParams({ brandId });
  if (categoryId) params.set("categoryId", categoryId);
  return `${agriMarketBase()}/brand?${params.toString()}`;
};

export const productDetailsPath = (productId, variantId) => {
  const path = `${agriMarketBase()}/product-details?id=${encodeURIComponent(productId)}`;
  return variantId ? `${path}&variantId=${encodeURIComponent(variantId)}` : path;
};
